import {FC, RefObject, useRef} from 'react'

import cn from 'classnames/bind'
import {CSSTransition} from 'react-transition-group'

import CloseIcon from 'src/assets/icons/close.svg'
import Portal from 'src/components/blocks/Portal'

import s from './BillingsTermsModal.module.scss'

const cx = cn.bind(s)

interface IModalProps {
	className?: string
	contentClassName?: string
	title?: string
	header?: string
	isOpen: boolean
	onClose: () => void
}

const BillingsTermsModal: FC<IModalProps> = ({
	children,
	className,
	contentClassName,
	title,
	header,
	isOpen,
	onClose,
	...attrs
}) => {
	const containerRef: RefObject<HTMLDivElement> = useRef(null)
	return (
		<Portal>
			<CSSTransition
				nodeRef={containerRef}
				in={isOpen}
				mountOnEnter
				unmountOnExit
				timeout={100}
				classNames={{...s}}>
				<div ref={containerRef} className={cx(className, 'containerWrapper')} {...attrs}>
					<div className={cx('wrapper')}>
						{header && (
							<div className={cx('header')}>
								<span>{header}</span>
								<button className={cx('closeIcon')} onClick={onClose}>
									<CloseIcon />
								</button>
							</div>
						)}
						<div className={cx('content', contentClassName)}>
							{title && <h1 className={cx('title')}>{title}</h1>}
							{children}
						</div>
					</div>
				</div>
			</CSSTransition>
		</Portal>
	)
}

export default BillingsTermsModal
